import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ProjectContextService } from "../../services/project-context.service";
import { ProjectSummary } from "../../models/api-dto.model";

export interface RenameProjectDialogData {
  project: ProjectSummary;
}

@Component({
  selector: "app-rename-project-dialog",
  templateUrl: "./rename-project-dialog.component.html",
  styleUrls: ["./rename-project-dialog.component.scss"],
  standalone: false
})
export class RenameProjectDialogComponent {
  projectName: string = "";
  isSubmitting: boolean = false;
  errorMessage: string = "";

  constructor(
    public dialogRef: MatDialogRef<RenameProjectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RenameProjectDialogData,
    private projectContext: ProjectContextService,
    private snackBar: MatSnackBar
  ) {
    this.projectName = data?.project?.name || "";
  }

  get isValid(): boolean {
    const trimmed = this.projectName.trim();
    return trimmed.length >= 2 && trimmed !== (this.data?.project?.name || "");
  }

  onSubmit(): void {
    if (!this.isValid || this.isSubmitting) return;

    this.isSubmitting = true;
    this.errorMessage = "";

    const newName = this.projectName.trim();
    this.projectContext.updateProjectName(this.data.project.id, newName).subscribe({
      next: (updated) => {
        this.isSubmitting = false;
        this.dialogRef.close(updated);
        this.snackBar.open(`Project renamed to "${newName}"`, undefined, { duration: 3000 });
      },
      error: (err) => {
        this.isSubmitting = false;
        this.errorMessage = err?.error?.message || "Failed to rename project. Please try again.";
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
